export default (string, currency = false) => {
  let status = true;
  if (isNaN(string)) {    
    let stringArray = string.split("");
    stringArray.forEach(char => {
      if (currency && char !== ",") {
        if (persianNumbers.indexOf(char) < 0) {
          status = false;
        }
      }else{
        if (persianNumbers.indexOf(char) < 0) {
          status = false;
        }
      }
    });
  }
  return status;
};
const persianNumbers = [
  "۰",
  "۱",
  "۲",
  "۳",
  "۴",
  "۵",
  "۶",
  "۷",
  "۸",
  "۹",
  "۰",
  "١",
  "٢",
  "٣",
  "٤",
  "٥",
  "٦",
  "٧",
  "٨",
  "٩"
];
